import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Auth0Provider } from "@auth0/auth0-react";

import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Auth0Provider
    domain="dev-0tlayqq58ct6b3xq.eu.auth0.com"
    clientId="MllH5tF2YWXLjnzBMxAjQblpuLAaNLfj"
    authorizationParams={{
      redirect_uri: window.location.origin,
      audience: "https://yardmanager.azurewebsites.net/api",
      scope: "",
    }}
  >
    <App />
  </Auth0Provider>
);

reportWebVitals();
